import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box } from '@mui/material';

const VehiclePricingTable = (props: any) => {
  const { vehiclePricing, currencyFormatter, locationCurrency } = props;
  return (
    <Box pr={2}>
      <TableContainer sx={{ borderRadius: '4px' }}>
        <Table sx={{ minWidth: 400 }} aria-label="simple table">
          <TableBody>
            <TableRow sx={{ border: 1, borderColor: '#E3E3E3' }}>
              <TableCell component="th" scope="row" sx={{ padding: '10px 8px', alignItems: 'center' }}>
                Additional Fee
              </TableCell>
              <TableCell align="right" sx={{ padding: '10px 8px', alignItems: 'center' }}>
                {currencyFormatter(vehiclePricing.additionalUpgradeFee, locationCurrency)}
              </TableCell>
            </TableRow>
            <TableRow sx={{ border: 1, borderColor: '#E3E3E3' }}>
              <TableCell component="th" scope="row" sx={{ padding: '10px 8px', alignItems: 'center' }}>
                Inventory Vehicle Price
              </TableCell>
              <TableCell align="right" sx={{ padding: '10px 8px', alignItems: 'center' }}>
                {currencyFormatter(vehiclePricing.inventoryVehiclePrice, locationCurrency)}
              </TableCell>
            </TableRow>
            <TableRow
              sx={{
                border: 1,
                borderColor: '#E3E3E3',
                '&:last-child td, &:last-child th': { bgcolor: '#f2f2f2', fontWeight: 'Bold' },
              }}
            >
              <TableCell component="th" scope="row" sx={{ padding: '10px 8px', alignItems: 'center' }}>
                Total Price
              </TableCell>
              <TableCell align="right" sx={{ padding: '10px 8px', alignItems: 'center' }}>
                {currencyFormatter(vehiclePricing.totalPrice, locationCurrency)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default VehiclePricingTable;
